import type { VideoWidgetData, VideoWidgetInput } from '../model/video-widget.types';

interface V0Data {
  version?: 0;
  settings?: VideoWidgetInput;
  input?: VideoWidgetInput;
}

type DataUnion = V0Data | VideoWidgetData;

function fromV0toV1(data: V0Data): VideoWidgetData {
  if (data.settings) data.input = data.settings;
  delete data.settings;

  return {
    version: 1,
    ...data,
  } as VideoWidgetData;
}

export function normalizeVersions(data: DataUnion | string): VideoWidgetData {
  const parsed = typeof data === 'string' ? (JSON.parse(data) as DataUnion) : data;

  if (!parsed.version) return fromV0toV1(parsed);

  return parsed;
}
